import { AppRoute } from '@common/app/routes';
import { gameItemOrder } from '@common/constants';
import { type RequirementType } from '@common/types/components';
import { factoryTypesArray, type FactoryTypeText } from '@common/types/factory';
import { type PlantTypeText } from '@common/types/plant';
import { type ResourceTypeText } from '@common/types/resource';

import { type GoodsType } from '@/common/types/goods';

interface CreateRequirementLinkProps {
  type: RequirementType;
  value: number;
  name:
    | ResourceTypeText
    | PlantTypeText
    | FactoryTypeText
    | GoodsType
    | undefined;
  plantLevel: number;
}

const createRequirementLink = ({
  type,
  value,
  name,
  plantLevel,
}: CreateRequirementLinkProps): string | undefined => {
  let link: string | undefined;

  if (type === 'cash') {
    link = AppRoute.STOCK;
  }
  const { resource, material, goods } = gameItemOrder;
  const gameItemSets = {
    resource: new Set(resource),
    material: new Set(material),
    goods: new Set(goods),
    factory: new Set(factoryTypesArray as string[]),
  };

  if (type === 'material' && name) {
    if (gameItemSets.resource.has(name)) {
      link = `${AppRoute.RESOURCES}/mineResource/${name}`;
    }

    if (gameItemSets.material.has(name)) {
      link = `${AppRoute.FACTORY}/${name}`;
    }

    if (gameItemSets.goods.has(name)) {
      link = `${AppRoute.WORKSHOP}/${name}`;
    }
  }

  const linkEnd = `/${value === 1 || (value > 1 && plantLevel === 0) ? 'build' : `${name}/upgrade`}`;

  if (type === 'quarry') {
    link = AppRoute.RESOURCES + linkEnd;
  }

  if (type === 'plant' && name) {
    if (gameItemSets.resource.has(name)) {
      link = AppRoute.RESOURCES + linkEnd;
    }

    if (gameItemSets.material.has(name)) {
      link = AppRoute.FACTORY + linkEnd;
    }

    if (gameItemSets.factory.has(name)) {
      link = AppRoute.WORKSHOP + linkEnd;
    }
  }

  return link;
};

export { createRequirementLink };
